/* eslint-disable react/jsx-props-no-spreading */
import { FC } from 'react';
import { Provider } from 'react-redux';
import { createReduxWrapper } from '@doda/common/src/redux/utils/createReduxWrapper';
import { ModalMasterData } from 'components/SearchSideBar/BasicInfo/types';
import { BreadCrumb } from '@doda/common/src/interfaces/breadCrumb';
import { MetaText } from '@doda/common/src/logics/metaTag';
import { KeywordsResultResponse } from '@doda/api-client/aspida/@types';
import { PrBannerResponse } from '@doda/common/src/interfaces/prBanner';
import { NearAreaDataType } from '@doda/common/src/interfaces/nearArea';
import { LinkBox } from '@doda/common/src/logics/seoFooterLinkData/createSeoFooterLink';
import { ButtonBox } from '@doda/common/src/logics/seoNarrowDownButtonData/createSeoNarrowDownButton';
import { reducer } from '@doda/pc/src/redux/store';
import { JobSearchListScreen } from './screens';
import { initServerSideProps } from './initServerSideProps';
import { SideBarProps } from './components/SearchSideBar/types';

/**
 * 検索結果一覧画面のprops
 */
export interface PageProps {
  sideBarProps: SideBarProps;
  modalMasterData: ModalMasterData;
  breadCrumb: BreadCrumb[];
  prBannerData: PrBannerResponse | null;
  isShowPagination: boolean;
  seoFooterLink: LinkBox[];
  leadSentence: string;
  explainText: string | null;
  metaTagData: MetaText;
  nearAreaData: NearAreaDataType | null;
  similarKeywordList: KeywordsResultResponse[];
  seoNarrowDownButtonData: ButtonBox[] | undefined;
}

const JobSearchList: FC<PageProps> = (props) => {
  const {
    store,
    props: { pageProps },
  } = wrapper.useWrappedStore(props);

  return (
    <Provider store={store}>
      <JobSearchListScreen {...pageProps} />
    </Provider>
  );
};

const wrapper = createReduxWrapper(reducer);

export const getServerSideProps =
  wrapper.getServerSideProps(initServerSideProps);

export default JobSearchList;
